import { useDispatch } from "react-redux";

import { setSection } from "../../../assignmentSlice";

import { useTTS } from "../../../../../hooks/useTTS";
import { typeInfo } from "../../../../../constants/typeInfo";

const ChoiceExamPage = ({
  section,
  pageList,
  currentPage,
  currentIndex,
  setCurrentIndex,
  setPageList,
  setOverlayVisible,
}) => {
  const dispatch = useDispatch();
  const { speak } = useTTS();

  const selectOption = ({ optionIndex }) => {
    const realIndex = optionIndex + 1;
    const isCorrect = realIndex === currentPage.answer;
    const newPageList = pageList.map((page, index) => {
      if (index === currentIndex) {
        return {
          ...page,
          isCorrect,
          input: realIndex,
          isSubmitted: true,
        };
      }
      return page;
    });
    setPageList(newPageList);
    dispatch(setSection({ ...section, answer: newPageList }));
    speak({ text: currentPage.word });

    setOverlayVisible(true);
    setTimeout(() => {
      if (isCorrect) {
        setTimeout(() => {
          if (currentIndex + 1 < pageList.length) {
            setCurrentIndex(currentIndex + 1);
          }
        }, 200);
      }
      setOverlayVisible(false);
    }, 600);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "75vw",
        gap: "30px",
      }}
    >
      <div
        style={{
          fontSize: "20px",
          textAlign: "center",
          color: "#737373",
        }}
      >
        {currentPage.question}
      </div>
      {currentPage.type === "example_blank_choice" && (
        <div
          style={{
            fontSize: "28px",
            textAlign: "center",
          }}
        >
          {currentPage.text1}
        </div>
      )}
      <div
        style={{
          fontSize: "28px",
          textAlign: "center",
        }}
      >
        {currentPage.text}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "14px",
        }}
      >
        {currentPage.choices.map((option, optionIndex) => {
          return (
            <div
              style={{
                textAlign: "center",
                padding: "16px 20px",
                border: "1px solid #EBEBEB",
                borderRadius: "5px",
                fontWeight:
                  currentPage.isSubmitted &&
                  (optionIndex + 1 === currentPage.answer ||
                    optionIndex + 1 === currentPage.input)
                    ? "bold"
                    : "normal",
                cursor: !currentPage.isSubmitted && "pointer",
                backgroundColor:
                  currentPage.isSubmitted &&
                  currentPage.answer === optionIndex + 1
                    ? typeInfo["vocabulary"].backgroundColor
                    : currentPage.input === optionIndex + 1 &&
                      "rgba(240, 52, 52, 0.5)",
                color:
                  currentPage.isSubmitted &&
                  currentPage.answer === optionIndex + 1
                    ? typeInfo["vocabulary"].color
                    : currentPage.input === optionIndex + 1 && "white",
                fontSize: "18px",
              }}
              onClick={() => {
                if (currentPage.isSubmitted) return;
                selectOption({ optionIndex });
              }}
            >
              {option}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ChoiceExamPage;
